import type * as React from 'react'

import { Button, ColorPicker, Heading, Text } from '@buffer-mono/popcorn'

import styles from './index.module.css'

interface LinksHeaderProps {
  colorButtons?: string
  textColor?: string
  maxCustomLinks?: number
  onAddLinkClick?: () => void
  setColorButton: (color: string) => void
  setTextColor: (color: string) => void
  onUpdateCustomLinksColor: (colors: {
    color: string
    contrastColor: string
  }) => void
  addLinkDisabled?: boolean
  hasWriteAccess: boolean
}

const LinksHeader = ({
  onAddLinkClick = () => {},
  setColorButton,
  setTextColor,
  maxCustomLinks,
  colorButtons,
  onUpdateCustomLinksColor,
  addLinkDisabled = false,
  hasWriteAccess,
}: LinksHeaderProps): React.ReactElement => {
  return (
    <div className={styles.header}>
      <div className={styles.title}>
        <Heading size="small"> Custom Links</Heading>

        <Text as="p" color="subtle">
          Add up to {maxCustomLinks} custom links to the top of your Shop grid
          page.
        </Text>
      </div>
      {hasWriteAccess && (
        <div className={styles.addLinkSection}>
          <div className={styles.linkColorSection}>
            <div className={styles.colorPickerWrapper}>
              <Text as="label">Link Color</Text>
              <ColorPicker
                defaultColor={colorButtons}
                onChange={(color, contrastColor): void => {
                  setColorButton(color)
                  setTextColor(contrastColor)
                }}
                onBlur={(color, contrastColor): void => {
                  setColorButton(color)
                  setTextColor(contrastColor)
                  onUpdateCustomLinksColor({
                    color: color || '',
                    contrastColor: contrastColor || '',
                  })
                }}
              >
                <ColorPicker.Trigger>
                  <Button variant="secondary">
                    <ColorPicker.Preview disabled /> <ColorPicker.Value />
                  </Button>
                </ColorPicker.Trigger>
                <ColorPicker.Content>
                  <ColorPicker.Swatch />
                  <ColorPicker.Input name="colorInput" />
                </ColorPicker.Content>
              </ColorPicker>
            </div>
          </div>
          <Button
            variant="primary"
            onClick={onAddLinkClick}
            disabled={addLinkDisabled}
          >
            Add Link
          </Button>
        </div>
      )}
    </div>
  )
}

export default LinksHeader
